import { Navigate, Outlet } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import LoginSideImage from '../assets/sideimage.png';
import { useCookiesLogin } from '../config/cookies';



export function AuthLayout() {
  const { cookies } = useCookiesLogin();

  if (cookies.AUTH_TOKEN) {
    return <Navigate to="/app/dashboard" replace />;
  }
  
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-white">
      <aside className="hidden lg:block">
        <img src={LoginSideImage} alt="Reduto Capital" className="w-full h-full object-cover" />
      </aside>

      <main className="relative flex-1 flex items-center justify-center px-6 py-10 bg-white overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
